import { createSlice } from "@reduxjs/toolkit";
import { fetchUsersListFromDb, backToSession, validateChannel, masterLogin } from "../services/operations/userSettingsApi";
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';

const initialState = {
    userData: [],
    validateMasterLoginUser: '',
    token: null,
    tokenDetails: [],
    loading: false,
    error: null,
    selectedUser: null,
};
const userSettingsSlice = createSlice({
    name: 'userSettings',
    initialState,
    reducers: {
        clearUserSessionData(state) {
            state.token = null;
            state.userDetails = null;
            Cookies.remove('jwt_token');
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUsersListFromDb.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchUsersListFromDb.fulfilled, (state, action) => {
            state.userData = action.payload.response.Users;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(fetchUsersListFromDb.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
        });

        builder
            .addCase(masterLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(masterLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.token = action.payload;
                const decoded = jwtDecode(action.payload);
                state.tokenDetails = {
                    email: decoded.email,
                    accountId: decoded.accountId,
                };
                Cookies.set('jwt_token', action.payload, { expires: 7, secure: true, sameSite: 'strict' });
            })
            .addCase(masterLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(validateChannel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(validateChannel.fulfilled, (state, action) => {
                state.loading = false;
                state.validateMasterLoginUser = action.payload;
                state.error = null;
            })
            .addCase(validateChannel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(backToSession.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(backToSession.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(backToSession.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearUserSessionData } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;